export default {
  getOperateLog: '/auth/operate/operateList',
  getOperateLogReport: '/auth/operate/exportOperateExcel',
};



// WEBPACK FOOTER //
// ./src/api/operationLog.js